/**
 * OwnerEmptyState — shared centered-card empty state for dashboard tabs
 * that have no data yet. Matches the "Action Needed" aesthetic on Overview:
 * gold-circle icon → heading → subtext → optional gold CTA.
 */
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

export default function OwnerEmptyState({
  icon: Icon,
  title,
  subtitle,
  ctaLabel,
  onCta,
  ctaHref,
  testid,
}) {
  const CtaWrap = ctaHref ? "a" : "button";
  const ctaProps = ctaHref
    ? { href: ctaHref }
    : { onClick: onCta, type: "button" };
  return (
    <div
      className="rounded-2xl border border-tbc-navy/10 bg-white p-10 flex flex-col items-center text-center max-w-xl mx-auto"
      data-testid={testid || "owner-empty-state"}
    >
      <div className="w-14 h-14 rounded-full bg-tbc-gold/15 flex items-center justify-center mb-5">
        {Icon ? <Icon className="w-6 h-6 text-tbc-gold" /> : null}
      </div>
      <h2 className="font-heading text-2xl text-tbc-navy leading-tight">{title}</h2>
      <p className="text-sm text-tbc-navy/60 mt-2 max-w-md">{subtitle}</p>
      {ctaLabel && (onCta || ctaHref) && (
        <CtaWrap
          {...ctaProps}
          className="mt-6 inline-flex items-center gap-1 rounded-full bg-tbc-gold px-5 py-2.5 text-sm font-semibold text-tbc-navy hover:bg-tbc-gold/90 no-underline"
          data-testid={`${testid || "owner-empty"}-cta`}
        >
          {ctaLabel} <ChevronRight className="w-4 h-4" />
        </CtaWrap>
      )}
    </div>
  );
}
